import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import CircleCounter from '../../components/circle-counter/CircleCounter';

const useScoutTabs = ({ isConsumer = false }) => {
  const { t } = useTranslation('scout');
  const isGenerating = useSelector((state) => state.scout.isGenerating);
  const finalMessagesCount = useSelector((state) => state.scout.finalMessagesCount);

  return useMemo(
    () => [
      {
        label: t('allMessages'),
        disabled: isGenerating,
      },
      {
        label: t('selectedMessages'),
        disabled: isGenerating,
      },
      {
        label: (
          <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            {t('finalMessages')}
            {/* <CircleCounter count={finalMessagesCount} /> */}
          </span>
        ),
        disabled: isGenerating,
      },
      {
        label: t('screenedMessages'),
        disabled: isGenerating,
      },
      ...(isConsumer
        ? []
        : [
            {
              label: t('backup'),
              disabled: isGenerating,
            },
          ]),
    ],
    [isGenerating, t, finalMessagesCount, isConsumer],
  );
};

export default useScoutTabs;
